import React from "react";
import GoBack from "shared/ui/GoBack";
import SearchContent from "widgets/SearchContent";

const Search: React.FC = () => {
  return (
    <main>
      <GoBack black />

      <SearchContent />
    </main>
  );
};

export default Search;
